import { render, staticRenderFns } from "./WBConfigCompoment.vue?vue&type=template&id=2fe32b58"
import script from "./WBConfigCompoment.vue?vue&type=script&lang=js"
export * from "./WBConfigCompoment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports